import vm from '~/main'
export default {
  $formatDate: (dateData) => {
    if (!dateData) return null
    let date, time, hours, minutes
    const [dateString, timeData] = (
      dateData.indexOf('T') !== -1
        ? new Date(dateData).toLocaleString('tr-TR', { timeZone: 'Europe/Helsinki' })
        : dateData
    ).split(' ')
    date = dateString
    time = timeData
    if (time) {
      hours = time.split(':')[0]
      minutes = time.split(':')[1]
    }
    // }
    let result
    if (date.indexOf('-') !== -1) {
      const [year, month, day] = date.split('-')
      result = `${day}.${month}.${year}`
    } else {
      result = date
    }
    if (hours && minutes) {
      result = result + ' ' + hours + ':' + minutes
    }
    return result
  },
  $parseDate: (dateData) => {
    if (!dateData) return null
    const [day, month, year] = dateData.split('.')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  },
  $formatTime: (time, report) => {
    if (time >= 60) {
      let result =
        ((time / 60) | 0) +
        ' ' +
        (report ? 't' : vm.localStorage.translations.pages.common.measure.hours_min)
      if (time % 60) {
        result =
          result +
          ' ' +
          (time % 60) +
          ' ' +
          (report ? 'm' : vm.localStorage.translations.pages.common.measure.minutes)
      }
      return result
    } else {
      return time + ' ' + (report ? 'm' : vm.localStorage.translations.pages.common.measure.minutes)
    }
  },
  $formatTimeMin: (time) => {
    if (time >= 60) {
      let hours = (time / 60) | 0
      let minutes = time % 60
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      let result = hours + ':' + minutes
      return result
    } else {
      if (time < 10) {
        time = '0' + time
      }
      return '00:' + time
    }
  },
  $getWeekNumber: (date) => {
    let currentdate = date ? new Date(date) : new Date()
    let oneJan = new Date(currentdate.getFullYear(), 0, 1)
    let numberOfDays = Math.floor((currentdate - oneJan) / (24 * 60 * 60 * 1000))
    let result = Math.ceil((currentdate.getDay() + 1 + numberOfDays) / 7)
    return result
  },
  $getDates: (startDate, stopDate, min) => {
    if (typeof startDate === 'string') {
      startDate = new Date(startDate)
    }
    if (typeof stopDate === 'string') {
      stopDate = new Date(stopDate)
    }
    var dateArray = new Array()
    var currentDate = startDate
    while (currentDate <= stopDate) {
      dateArray.push(
        !min ? new Date(currentDate) : new Date(currentDate).toISOString().slice(0, 10),
      )
      currentDate = currentDate.addDays(1)
    }
    return dateArray
  },
  $convertMillisToMinutesAndSeconds(millis) {
    let minutes = Math.floor(millis / 60000)
    let seconds = ((millis % 60000) / 1000).toFixed(0)
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
  },
}
